import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "currentBreakpoint", "activePanelType", "onClose", "children", "innerRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useClickOutside, useKeyPress } from '@lmig/lmds-react-hooks';
import { BREAKPOINTS } from '@lmig/lmds-helpers/dist/constants/breakpoints';
import FocusLock from 'react-focus-lock';
import { PortalContainer } from './PortalContainer';
export var ContainerOverlayTakeover = function ContainerOverlayTakeover(_ref) {
  var id = _ref.id,
    className = _ref.className,
    currentBreakpoint = _ref.currentBreakpoint,
    activePanelType = _ref.activePanelType,
    onClose = _ref.onClose,
    children = _ref.children,
    innerRef = _ref.innerRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // if breakpoint is base and panel type is overlay, we display the dark backdrop.
  // Triggers the onClose function when the escape key is pressed.
  useKeyPress('Escape', onClose);
  // Triggers the onClose function when the user clicks outside the panel container.
  useClickOutside(innerRef === null || innerRef === void 0 ? void 0 : innerRef.current, onClose);
  return /*#__PURE__*/React.createElement(PortalContainer, null, /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: className,
    role: "dialog",
    ref: innerRef
  }, otherProps), /*#__PURE__*/React.createElement(FocusLock, {
    returnFocus: true
  }, children)), currentBreakpoint === BREAKPOINTS[0] && activePanelType === 'overlay' && /*#__PURE__*/React.createElement("div", {
    className: "lmig-Panel-backdrop",
    "aria-hidden": true
  }));
};
ContainerOverlayTakeover.propTypes = {
  onClose: _pt.func.isRequired
};